module.exports = __webpack_public_path__ + "img/content-while.90582395.png";